import { getPlatform } from '@/helpers/getPlatform';
import { Platform } from '@/constants';

const platformId = getPlatform();

export const usePlatform = () => {
    const id = platformId;

    const isTradeball = (): boolean => id === Platform.Tradeball;
    const isWL = (): boolean => id !== Platform.Tradeball;
    const isAggregator = (): boolean => id === Platform.Tradeball || id === Platform.Oddjusta;
    const isBookmaker = (): boolean => id !== Platform.Tradeball && id !== Platform.Oddjusta;

    return { id, isTradeball, isBookmaker, isAggregator, isWL };
};
